import { WorkflowPhase } from '@blaze-shared/workflow-domain';

export type SourceWorkflowOutcome = 'delivered' | 'settledWithoutOutput' | 'unstarted' | 'pending';

export interface SourceWorkflowOutcomeInputs {
  hasStatus: boolean;
  phase: WorkflowPhase | undefined;
  hasOutput: boolean;
  isRunning: boolean;
  isQueued: boolean;
}

export function deriveSourceWorkflowOutcome(
  inputs: SourceWorkflowOutcomeInputs,
): SourceWorkflowOutcome {
  const { hasStatus, phase, hasOutput, isRunning, isQueued } = inputs;

  if (hasOutput) {
    return 'delivered';
  }
  if (hasStatus) {
    return phase === WorkflowPhase.Blocked || phase === WorkflowPhase.Error
      ? 'settledWithoutOutput'
      : 'pending';
  }
  return isQueued || !isRunning ? 'pending' : 'unstarted';
}
